import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import "./Tabs.scss";

const Tabs = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="tabs">
      {data
        .filter((d) => !d.hide)
        .map((d) => {
          return (
            <NavLink
              key={d.to}
              to={d.to}
              title={t(d.title)}
              className={(navData) => {
                return classNames({ active: navData.isActive });
              }}
            >
              <span
                className={classNames("highlighted", {
                  active: d.highlighted,
                })}
              ></span>
              {t(d.title)}
            </NavLink>
          );
        })}
    </div>
  );
};

Tabs.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      hide: PropTypes.bool,
      highlighted: PropTypes.bool,
    })
  ),
};

export default Tabs;
